import { Component, Input } from '@angular/core';
import { NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'app-ngb-confirm-delete-modal',
  styleUrls: ['../../style/common-styles.scss'],
  template: `
    <div class="modal-header">
      <h4 class="modal-title">Confirm Delete</h4>
      <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <p [innerHTML]="message"></p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark primary-button" (click)="activeModal.close('Close click')">Delete</button>
      <button type="button" class="btn btn-outline-dark danger-button" (click)="activeModal.dismiss('Dismissed')">Cancel</button>
    </div>
  `
})
export class NgbModalConfirmDeleteComponent {
  @Input() message: string;

  constructor(public activeModal: NgbActiveModal) {}
}

